import "./triad.css";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../utils";
import { useContext } from "react";
import { AuthContext } from "../../../context";
import { useAlert } from "../../../context/AlertContext";

const CourseCard = ({
  createdBy,
  title,
  createdAt,
  _id,
  description,
  image,
}: any) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const handleCourseNavigation = () => {
    if (user?.role === "Admin") {
      navigate(`/app/courses/${_id}`);
      return;
    }
    if (
      !user?.isPremium &&
      (user?.role === "Growth" || user?.role === "Investor")
    ) {
      showAlert({
        type: "error",
        title: "Oops",
        text: "Please subscribe to access any training",
      });
      return;
    }

    navigate(`/app/courses/${_id}`);
  };

  // console.log("image=>", image);
  return (
    <>
      <article className="triad-course-card">
        <header className="triad-course-header">
          <div className="triad-logo-mini">triad</div>
          <span className="triad-tag">Masterclass</span>
        </header>

        <div className="triad-course-image">
          <img
            src={`https://triad.africa/${image}`}
            alt={`${title} cover`}
            loading="lazy"
          />
        </div>
        <h3>{title}</h3>
        <p className="triad-course-desc">{description}</p>

        <div className="triad-course-meta">
          <span>Uploaded:</span>
          <span>{formatDate(createdAt)}</span>
        </div>

        {/* <div className="triad-progress">
          <div className="triad-progress-bar">
            <div className="triad-progress-fill" style={{ width: "0%" }} />
          </div>
          <span className="triad-progress-label">0% complete</span>
        </div> */}

        <button
          className="triad-btn-outline"
          onClick={handleCourseNavigation}
          type="button"
        >
          Start
        </button>
      </article>
    </>
  );
};

export default CourseCard;
